//
//
//
//
//
//
//
//
//
//
//
//

import Icon from '../icon'
import { Flexbox, FlexboxItem } from '../flexbox'

const sizeMap = {
  'large': 40,
  'middle': 30,
  'small': 20
}
export default {
  components: {
    Icon,
    Flexbox,
    FlexboxItem
  },
  created () {
    this.currentValue = this.value
  },
  props: {
    colors: {
      type: Array,
      required: true
    },
    size: {
      type: String,
      default: 'large'
    },
    value: String
  },
  computed: {
    width () {
      return sizeMap[this.size]
    }
  },
  data () {
    return {
      currentValue: ''
    }
  },
  watch: {
    value (val) {
      this.currentValue = val
    },
    currentValue (color) {
      this.$emit('on-change', color)
      this.$emit('input', color)
    }
  },
  methods: {
    change (color) {
      this.currentValue = color
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/color-picker/index.vue